/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl, setFetchGraphQlHeader, config } from '@/auth/api';
import { GET_CUSTOMER_DATA } from './graphql/getCustomerData.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { CustomerModel } from '@/auth/data/models';
import { transformCustomerData } from '@/auth/data/transforms';

export const getCustomerData = async (
  user_token: string
): Promise<CustomerModel> => {
  if (user_token) {
    const { authHeaderConfig } = config.getConfig();

    setFetchGraphQlHeader(
      authHeaderConfig.header,
      authHeaderConfig.tokenPrefix
        ? `${authHeaderConfig.tokenPrefix} ${user_token}`
        : user_token
    );
  }

  return await fetchGraphQl(GET_CUSTOMER_DATA, {
    method: 'GET',
    cache: 'force-cache',
  })
    .then((response) => {
      return transformCustomerData(response);
    })
    .catch(handleNetworkError);
};
